import script from "./BottomComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BottomComponent.vue?vue&type=style&index=0&id=0dcfbb22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcfbb22"]])

export default __exports__